var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailSignupLeft = function SvgEmailSignupLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 150,
    viewBox: "0 0 349 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.277 96.607h-6.694v-9.374L7.64 72.98-8.305 87.233v9.374H-15V84.24L7.64 64l22.637 20.24v12.367zM30.28 101.515H-15v6.721h45.28v-6.721z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349 149.112h-27.945V109.98l-66.548-59.489-66.562 59.489v39.132H160V97.488L254.507 13 349 97.488v51.624z",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.824.2h-5.297v7.418L92.913 18.894 80.297 7.618V.2H75v9.785L92.913 26l17.911-16.014V.2z"
  })));
};
export default SvgEmailSignupLeft;